import { render, staticRenderFns } from "./QueueSignup.vue?vue&type=template&id=3d5712ae"
import script from "./QueueSignup.vue?vue&type=script&lang=ts"
export * from "./QueueSignup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports